export const getPrecisePercentages = (values: number[], precision = 2): number[] => {
    const total = values.reduce((sum, v) => sum + v, 0)
    if (total === 0) return values.map(() => 0)

    const power = Math.pow(10, precision)
    const target = 100 * power

    const percents = values.map(v => (v / total) * target)
    const floored = percents.map(p => Math.floor(p))
    const remainders = percents.map((p, i) => ({
        diff: p - floored[i],
        index: i,
    }))

    const currentSum = floored.reduce((a, b) => a + b, 0)
    const diff = target - currentSum

    // Sort by largest remainder to distribute the difference
    remainders.sort((a, b) => b.diff - a.diff)

    for (let i = 0; i < diff; i++) {
        floored[remainders[i].index]++
    }

    return floored.map(p => p / power)
}

export const formatPercentage = (value: number): string => {
    // Number() conversion removes trailing zeros and the decimal point if it's an integer
    return Number(value.toFixed(2)).toString()
}
